import React from "react"

import BundledPaymentsLayout from "../../components/bundled-payments/layout"
import SectionHero from "../../components/bundled-payments/cjr-x/section-hero"
import SectionChallenges from "../../components/bundled-payments/cjr-x/section-challenges"
import SectionHowItWorks from "../../components/bundled-payments/cjr-x/section-how-it-works"
import SectionResults from "../../components/bundled-payments/cjr-x/section-results"
import SectionTrust from "../../components/bundled-payments/cjr-x/section-trust"
import SectionHelp from "../../components/bundled-payments/cjr-x/section-help"
import SectionCta from "../../components/bundled-payments/cjr-x/section-cta"

const CjrxPage = ({ location }) => (
  <BundledPaymentsLayout
    location={location}
    title="CJR-X Readiness"
    description="CJR-X is mandatory for most hospitals from January 1, 2028, with two-sided risk from year one. See where your hospital stands against your region now."
    footerNote="Results vary by hospital. Reconciliation outcomes depend on CMS methodology, patient mix, and the actions each hospital takes. Avant-garde Health does not guarantee reconciliation results."
    pageId="cjrx"
  >
    <SectionHero />
    <SectionChallenges />
    <SectionHowItWorks />
    <SectionResults />
    <SectionTrust />
    <SectionHelp />
    <SectionCta />
  </BundledPaymentsLayout>
)

export default CjrxPage
